import * as patients from '@seen/core/models/patients'
import { Badge, type BadgeProps } from '@seen/ui'
import type { ReactNode } from 'react'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '#src/components/core/index.ts'

export function ParticipantFlagBadge({
  flag,
  label,
  leadingIcon,
  className,
  size,
  disableTooltip,
}: {
  flag: patients.ParticipantFlagDefinition
  label?: string
  leadingIcon?: ReactNode
  className?: string
  size?: BadgeProps['size']
  disableTooltip?: boolean
}): ReactNode {
  const badge = (
    <Badge
      className={className}
      color={participantFlagColors[flag.priority]}
      size={size}
      variant="outline"
    >
      {leadingIcon}
      {label ?? flag.coding.display}
    </Badge>
  )
  if (!flag.description || disableTooltip) {
    return badge
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>{badge}</TooltipTrigger>
      <TooltipContent>{flag.description}</TooltipContent>
    </Tooltip>
  )
}

const participantFlagColors: Record<
  patients.ParticipantFlagPriority,
  BadgeProps['color']
> = {
  [patients.ParticipantFlagPriority.P0]: 'red',
  [patients.ParticipantFlagPriority.P1]: 'orange',
  [patients.ParticipantFlagPriority.P2]: 'yellow',
  [patients.ParticipantFlagPriority.P3]: 'default',
}
